import { TFunction } from 'i18next';
import { WaitingListItemData } from '../../../../api';
import { ExportColumn } from '../../../../common/export/exportTypes';

export const buildWaitingListExportColumns = (t: TFunction): ExportColumn<WaitingListItemData>[] => [
  { key: 'firstname', header: t('export.firstname'), value: (item) => item.firstname },
  { key: 'lastname', header: t('export.lastname'), value: (item) => item.lastname },
  { key: 'persons', header: t('waitinglist.num_persons'), value: (item) => item.persons },
  { key: 'email', header: t('waitinglist.email'), value: (item) => item.email },
  { key: 'phone', header: t('waitinglist.phone'), value: (item) => item.phone },
];
